import Modal from "app/components/Modal"
import React from "react"
import AddRelease from "./AddRelease"

interface AddReleaseModalProps {
    onClose: () => void
}

export default function AddReleaseModal({ onClose }: AddReleaseModalProps) {
    return (
        <Modal
            onClose={onClose}
            submitText="Add"
            title="Add new release"
            contentClassName="!p-0"
            modalClassName="!w-[388px] !max-w-[388px]"
        >
            <AddRelease />
        </Modal>
    )
}